/**
 * Application constants
 *
 * @export
 * @class Constants
 */
export class Constants {

    static AppScope = 'NG';

    static Urls = {
        AppConfig: './assets/appconfig.json',
        Translations: './assets/i18n/',
        Assets: './assets/'
    };

    static ContentType = {
        JSON: 'application/json',
        XML: 'application/xml'
    };

    static Header = {
        Request: {
            ContentType: 'Content-Type',
            Authorization: 'CLX-Authorization',
            XIgnoreMessageIds: 'X-Ignore-Message-Ids'
        }
    };

    static UrlParams = {
        AccessToken: 'access_token',
        Code: 'code',
        DateFrom: 'dateFrom',
        DateTo: 'dateTo',
        ExpiresIn: 'expires_in',
        RefreshToken: 'refresh_token',
        TokenType: 'token_type'
    };

    static RequestBodyParams = {
        AccessToken: 'access_token',
        Code: 'code',
        ResponseType: 'response_type',
        CodeChallenge: 'code_challenge',
        CodeChallengeMethod: 'code_challenge_method'
    };

    static ReservationsRecht = {
        None: -220,
        Reservable: 221, // buchbar
        ProvReservable: 222, // provisorisch buchbar
        Requestable: 223, // anfragbar
        Visible: 224 // nur sichtbar
    };
}
